'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _candidate = require('./candidate.vue');

var _candidate2 = _interopRequireDefault(_candidate);

var _checkbox = require('./checkbox.vue');

var _checkbox2 = _interopRequireDefault(_checkbox);

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _TweenLite = require('../../../../node_modules/gsap/src/uncompressed/TweenLite');

var _TweenLite2 = _interopRequireDefault(_TweenLite);

require('../../../../node_modules/gsap/src/uncompressed/plugins/CSSPlugin');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.transition('stagger', {
    beforeLeave: function beforeLeave() {
        var candidateContainer = document.querySelector('.candidates__list');
        candidateContainer.style.minHeight = candidateContainer.scrollHeight + 'px';
    },
    leave: function leave() {
        var candidateContainer = document.querySelector('.candidates__list');
        //                candidateContainer.style.minHeight = ''
        _TweenLite2.default.to(candidateContainer, 0.2, {
            css: {
                minHeight: 0
            }
        });
    }

});
exports.default = {
    data: function data() {
        return {
            group1: [],
            group2: '',
            group3: '',
            currentPage: 0,
            itemsPerPage: 4,
            resultCount: 0,
            candidates: []
        };
    },

    components: {
        candidate: _candidate2.default,
        checkbox: _checkbox2.default
    },
    computed: {
        totalPages: function totalPages() {
            return Math.ceil(this.resultCount / this.itemsPerPage);
        }
    },
    ready: function ready() {
        this.fetchCandidates();
    },

    methods: {
        setPage: function setPage(pageNumber) {
            this.currentPage = pageNumber;
        },
        clearFilter: function clearFilter(event) {
            var checkboxes = document.querySelectorAll('.checkbox');
            this.group1 = [];
            this.currentPage = 0;
            for (var i = 0; i < checkboxes.length; i++) {
                checkboxes[i].checked = false;
            }
            return event.target.checked = true;
        },
        fetchCandidates: function fetchCandidates() {
            this.$http.get('assets/js/recipes.json').then(function (candidates) {
                this.$set('candidates', candidates.data.recipes);
                this.$set('resultCount', candidates.data.recipes.length);
            });
        }
    },
    filters: {
        recipesFilter: function recipesFilter(candidates) {
            var group = this.group1;
            if (group.length > 0) {
                var candidatesFiltered = candidates.filter(function (candidate) {
                    return candidate.categories.filter(function (category) {
                        return group.indexOf(category) > -1;
                    }).length === group.length;
                });
                return candidatesFiltered;
            } else {
                return candidates;
            }
        },
        paginate: function paginate(list) {
            this.resultCount = list.length;
            if (this.currentPage >= this.totalPages) {
                this.currentPage = this.totalPages;
            }
            var index = this.currentPage * this.itemsPerPage;
            return list.slice(index, index + this.itemsPerPage);
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"candidates__overview\">\n    <div class=\"candidates__filter\">\n        <div class=\"candidates__filterGroup candidates__filterGroup--01\">\n            <div class=\"filter__radio\">\n                <input type=\"checkbox\" @click=\"setPage(0)\" class=\"checkbox\" value=\"veggie\" id=\"group1--1\" name=\"group1\" v-model=\"group1\">\n                <label class=\"checkbox__label\" for=\"group1--1\">\n                    <checkbox></checkbox>\n                    Veggie\n                </label>\n            </div>\n            <div class=\"filter__radio\">\n                <input type=\"checkbox\" @click=\"setPage(0)\" class=\"checkbox\" value=\"nonveggie\" id=\"group1--2\" name=\"group1\" v-model=\"group1\">\n                <label class=\"checkbox__label\" for=\"group1--2\">\n                    <checkbox></checkbox>\n                    Non Veggie\n                </label>\n            </div>\n            <div class=\"filter__radio\">\n                <input type=\"checkbox\" @click=\"setPage(0)\" class=\"checkbox\" value=\"suess\" id=\"group1--3\" name=\"group2\" v-model=\"group1\">\n                <label class=\"checkbox__label\" for=\"group1--3\">\n                    <checkbox></checkbox>\n                    Süß\n                </label>\n            </div>\n            <div class=\"filter__radio\">\n                <input type=\"checkbox\" @click=\"setPage(0)\" class=\"checkbox\" value=\"herzhaft\" id=\"group1--4\" name=\"group1\" v-model=\"group1\">\n                <label class=\"checkbox__label\" for=\"group1--4\">\n                    <checkbox></checkbox>\n                    Herzhaft\n                </label>\n            </div>\n            <div class=\"filter__radio\">\n                <input type=\"checkbox\" @click=\"setPage(0)\" class=\"checkbox\" value=\"bodenstaendig\" id=\"group1--5\" name=\"group1\" v-model=\"group1\">\n                <label class=\"checkbox__label\" for=\"group1--5\">\n                    <checkbox></checkbox>\n                    Bodenständig\n                </label>\n            </div>\n            <div class=\"filter__radio\">\n                <input type=\"checkbox\" @click=\"setPage(0)\" class=\"checkbox\" value=\"experimental\" id=\"group1--6\" name=\"group1\" v-model=\"group1\">\n                <label class=\"checkbox__label\" for=\"group1--6\">\n                    <checkbox></checkbox>\n                    Experimental\n                </label>\n            </div>\n            <!--<div class=\"filter__radio\">-->\n                <!--<input type=\"checkbox\" class=\"checkbox\" value=\"\" id=\"group1&#45;&#45;7\" name=\"group1\" @click=\"clearFilter($event)\">-->\n                <!--<label class=\"checkbox__label\" for=\"group1&#45;&#45;7\">-->\n                    <!--<checkbox></checkbox>-->\n                    <!--Keine Filterung-->\n                <!--</label>-->\n            <!--</div>-->\n        </div>\n    </div>\n\n    <div class=\"candidates__list\">\n        <candidate transition=\"stagger\" v-for=\"candidate in candidates | recipesFilter | paginate\" :candidate=\"candidate\" :index=\"$index\"></candidate>\n    </div>\n\n    <ul class=\"candidates__pagination pagination\">\n        <li v-for=\"pageNumber in totalPages\">\n            <a href=\"javascript:void(0);\" @click=\"setPage(pageNumber)\" class=\"pagination__item\" :class=\"{paginationCurrent: currentPage === pageNumber}\">{{ pageNumber + 1}}</a>\n        </li>\n    </ul>\n</div>\n\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-52835f0a", module.exports)
  } else {
    hotAPI.update("_v-52835f0a", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}